// extracted by mini-css-extract-plugin
export default {"container":"recommendedJobList_container__f1rGe"};